var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,21V3h6.46a9.16,9.16,0,0,1,5.29,1.27A4.23,4.23,0,0,1,18.59,8,4.37,4.37,0,0,1,18,10.36a3.71,3.71,0,0,1-1.9,1.45,3.8,3.8,0,0,1,2.17,1.39A4,4,0,0,1,19,15.67a4.79,4.79,0,0,1-1.67,4,8,8,0,0,1-5,1.35ZM9.37,10.5h2.26a3.17,3.17,0,0,0,2-.52,1.86,1.86,0,0,0,.6-1.5,2,2,0,0,0-.65-1.64,3.55,3.55,0,0,0-2.12-.5H9.37Zm0,2.85v4.31h2.84a2.69,2.69,0,0,0,1.8-.54,1.84,1.84,0,0,0,.64-1.51,2,2,0,0,0-2.24-2.26Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.bce57ccf2425e44d749d1384309f3fb4.svg";
export { ForwardRef as ReactComponent };